import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import SideNav from './SideNav';
import { NavContext, NavGroup } from './sideNavConfig';

interface RoleSideNavProps {
  context: NavContext;
  groups?: NavGroup[];
  disabled?: boolean;
  ariaLabel?: string;
  collapseStorageKey: string;
  openStorageKey?: string;
}

const readCollapsed = (key: string): boolean => {
  try {
    return window.localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const persistCollapsed = (key: string, value: boolean): void => {
  try {
    window.localStorage.setItem(key, value ? '1' : '0');
  } catch {
    /* ignore */
  }
};

const RoleSideNav: React.FC<RoleSideNavProps> = ({
  context,
  groups,
  disabled = false,
  ariaLabel,
  collapseStorageKey,
  openStorageKey,
}) => {
  const compact = useMediaQuery('(max-width:1500px)');

  const [collapsed, setCollapsed] = useState<boolean>(() =>
    readCollapsed(collapseStorageKey)
  );

  const toggleCollapsed = () =>
    setCollapsed((prev) => {
      const next = !prev;
      persistCollapsed(collapseStorageKey, next);
      return next;
    });

  return (
    <SideNav
      context={context}
      groups={groups}
      openStorageKey={openStorageKey}
      ariaLabel={ariaLabel}
      disabled={disabled}
      compact={compact}
      collapsed={collapsed}
      onToggleCollapse={toggleCollapsed}
    />
  );
};

export default RoleSideNav;
